<template>
  <BootstrapModal
    class="ProductSelector"
    v-on="$listeners"

    @save="addProducts"
  >
    <ProductFinder
      v-model="products"
    />

    <template #title>
      {{ title }}
    </template>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import ProductFinder from "@/components/Product/ProductFinder/ProductFinder"

export default {
  components: {
    BootstrapModal,
    ProductFinder,
  },
  props: ['title', 'callback'],
  data() {
    return {
      products: [],
    }
  },
  methods: {
    addProducts() {
      this.callback(this.products.map(product => ({
        price: parseFloat(product.price),
        qty: product.qty,
        name: product.name,
        sku: product.sku,
        src: product.src,
      })))
      this.$emit('close')
    },
  },
}

</script>

<style scoped>

.ProductSelector {
  width: 800px;
  min-height: 500px;
}

</style>
